"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addSignedUrlsToBroadcast = addSignedUrlsToBroadcast;
exports.attendeesWithCameraOn = void 0;
exports.combineSources = combineSources;
exports.filterUnassignedSources = void 0;
exports.findAndUpdateEmptySourceTitle = findAndUpdateEmptySourceTitle;
exports.findAndUpdateSource = findAndUpdateSource;
exports.getAttendeeIds = getAttendeeIds;
exports.getAttendeesNextMuteStatuses = getAttendeesNextMuteStatuses;
exports.getBroadcastSourcesFromLayers = getBroadcastSourcesFromLayers;
exports.getGroupSources = getGroupSources;
exports.getMediaSourceValueObject = getMediaSourceValueObject;
exports.getSceneLayerIds = getSceneLayerIds;
exports.getScreenShareCount = getScreenShareCount;
exports.getShouldApproveScreenShares = void 0;
exports.getSignedUrlsResponse = getSignedUrlsResponse;
exports.getStartedOn = getStartedOn;
exports.getUpdatedSceneLayers = getUpdatedSceneLayers;
exports.hasMeetingExceededCameraLimit = void 0;
exports.isCameraSource = isCameraSource;
exports.isMediaSource = isMediaSource;
exports.isMediaSourceExcludeAudio = isMediaSourceExcludeAudio;
exports.isSourceInLayer = isSourceInLayer;
exports.mapSignedUrlsToSources = mapSignedUrlsToSources;
exports.markPresenterSourcesInitializing = markPresenterSourcesInitializing;
exports.orderSources = orderSources;
exports.readFileAsBinary = readFileAsBinary;
exports.retainPDFURLsInSources = retainPDFURLsInSources;
exports.sourcesWithPreviousDisconnectedState = sourcesWithPreviousDisconnectedState;
exports.toggleBannerStatus = void 0;
exports.toggleStatus = toggleStatus;
exports.transferAudioSourceLayer = transferAudioSourceLayer;
exports.updateProgramIfBackgroundImagePresignedUrlExpired = updateProgramIfBackgroundImagePresignedUrlExpired;
exports.uploadEventDoc = uploadEventDoc;
exports.uploadForm = uploadForm;
exports.willExceedCameraLimit = willExceedCameraLimit;
var _axios = _interopRequireDefault(require("axios"));
var _moment = _interopRequireDefault(require("moment"));
var _checkSourceTypes = require("@studio/sources/checkSourceTypes");
var _getSources = require("@studio/sources/getSources");
var _Sources = require("@studio/constants/Sources");
var _SceneLayouts = require("@studio/constants/SceneLayouts");
var _Banners = require("@studio/constants/Banners");
var _MediaPlayer = require("@studio/constants/MediaPlayer");
var _Knocks = require("@studio/constants/Knocks");
var _Vendor = require("@studio/constants/Vendor");
var _StudioLogger = require("@studio/logger/StudioLogger");
var _underscore = _interopRequireDefault(require("underscore"));
var _constants = require("../constants");
var _time = require("./time");
var _featureFlags = require("@studio/feature.flags/featureFlags");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var logger = new _StudioLogger.StudioLogger('actions-utils');

/**
 * @param {Array} sources
 */
function orderSources(sources) {
  return _toConsumableArray(sources).sort(function (a, b) {
    return a.order - b.order;
  });
}

/**
 * Get layer broadcast sources
 * Need to make sure the layer sources exist in the broadcastSources array
 */
function getBroadcastSourcesFromLayers(layers, broadcastSources) {
  return layers.map(function (layer) {
    return layer.source;
  }).filter(function (source) {
    return broadcastSources.find(function (bs) {
      return [source._id, source.value].includes(bs._id);
    });
  });
}
var signedURLsCache = {
  lastUpdated: new Date().getTime()
};

/**
 * Get an object value even when the value is in "legacy" format for media sources (used to be just the event doc ID)
 * @param {*} value
 */
function getMediaSourceValueObject(value) {
  return typeof value === 'string' ? {
    eventDocId: value
  } : value;
}
function getSignedUrlsResponse(items, signedUrls) {
  var response = items.map(function (item) {
    if (item === 'SCENE_LAYER' || !item.source) {
      return item;
    }
    var _item$source = item.source,
      value = _item$source.value,
      type = _item$source.type;
    if (![_Sources.IMAGE_FILE, _Sources.VIDEO_FILE, _Sources.AUDIO_FILE, _Sources.PDF_FILE].includes(type) || (value === null || value === void 0 ? void 0 : value.type) === _Sources.STOCK_MEDIA) {
      return item;
    }
    var objectValue = getMediaSourceValueObject(value);
    return _objectSpread(_objectSpread({}, item), {}, {
      layer: _objectSpread({}, item.layer),
      source: _objectSpread(_objectSpread({}, item.source), {}, {
        value: _objectSpread(_objectSpread({}, objectValue), {}, {
          url: signedUrls[objectValue.eventDocId]
        })
      })
    });
  });
  return response;
}

/**
 *
 * @param {*} raw - url string eg. 'url(https://studio-docs-sg50-cvent-event-dev.s3.amazonaws.com/teams/56fd701dabdd86bf147cc9ba/events/56fd701dabdd86bf147cc9c1/docs/867507_Studio%20Background%203-1_1021120-754cd79d-1619176450881.png?AWSAccessKeyId=ASIAYRZKHVFTLNWRLO4I&Expires=1718016149)'
 * @returns '/teams/56fd701dabdd86bf147cc9ba/events/56fd701dabdd86bf147cc9c1/docs/867507_Studio%20Background%203-1_1021120-754cd79d-1619176450881.png'
 */
function getResourceS3Key(raw) {
  var matches = raw.match(/:\/\/(.[^/]+)(.*)/);
  var parsedUrl = new URL("http://".concat(matches[1]).concat(matches[2]));
  return parsedUrl.pathname;
}

/**
 * This function checks the broadcast background layerSource objects to find a match with the program style background image.
 * If a match is found, it updates the program background image with the layer source URL from the background layerSource,
 * ensuring that a valid URL is used for the background style.
 * @param {*} broadcast
 * @param {*} teamId
 * @param {*} eventId
 * @param {*} apiClient
 */
function updateProgramIfBackgroundImagePresignedUrlExpired(_x, _x2, _x3, _x4) {
  return _updateProgramIfBackgroundImagePresignedUrlExpired.apply(this, arguments);
}
function _updateProgramIfBackgroundImagePresignedUrlExpired() {
  _updateProgramIfBackgroundImagePresignedUrlExpired = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(broadcast, teamId, eventId, apiClient) {
    var programBackgroundImage, programBackgroundImageS3Key;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          programBackgroundImage = broadcast && broadcast.program && broadcast.program.style && broadcast.program.style.backgroundImage || '';
          if (!(!programBackgroundImage || !broadcast.backgrounds)) {
            _context2.n = 1;
            break;
          }
          return _context2.a(2);
        case 1:
          programBackgroundImageS3Key = getResourceS3Key(programBackgroundImage);
          _underscore["default"].each(broadcast.backgrounds, /*#__PURE__*/function () {
            var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(background) {
              var backgroundImagePresignedUrl;
              return _regenerator().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    backgroundImagePresignedUrl = background.source.value.url;
                    if (!(backgroundImagePresignedUrl && getResourceS3Key(backgroundImagePresignedUrl) === programBackgroundImageS3Key && programBackgroundImage != "url(".concat(backgroundImagePresignedUrl, ")"))) {
                      _context.n = 1;
                      break;
                    }
                    broadcast.program.style.backgroundImage = "url(".concat(backgroundImagePresignedUrl, ")");
                    _context.n = 1;
                    return apiClient.broadcast.updateProgram(teamId, eventId, broadcast._id, broadcast.program);
                  case 1:
                    return _context.a(2);
                }
              }, _callee);
            }));
            return function (_x16) {
              return _ref.apply(this, arguments);
            };
          }());
        case 2:
          return _context2.a(2);
      }
    }, _callee2);
  }));
  return _updateProgramIfBackgroundImagePresignedUrlExpired.apply(this, arguments);
}
function mapSignedUrlsToSources(_x5, _x6, _x7, _x8) {
  return _mapSignedUrlsToSources.apply(this, arguments);
}
function _mapSignedUrlsToSources() {
  _mapSignedUrlsToSources = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(items, apiClient, team, event) {
    var isS3ProxyStatusUpdate,
      minutes,
      isValidCache,
      eventDocIds,
      _yield$apiClient$even,
      urls,
      response,
      message,
      _args3 = arguments,
      _t;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.p = _context3.n) {
        case 0:
          isS3ProxyStatusUpdate = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : false;
          if (!(items == null || items.length === 0)) {
            _context3.n = 1;
            break;
          }
          return _context3.a(2, []);
        case 1:
          minutes = (0, _time.getMinutesDifference)(signedURLsCache.lastUpdated, new Date().getTime());
          isValidCache = minutes < _constants.SIGNED_URLS_CACHE_TIMEOUT_VALUE;
          eventDocIds = items.reduce(function (acc, item) {
            if (item === 'SCENE_LAYER' || !item.source) {
              return acc;
            }
            var _item$source2 = item.source,
              value = _item$source2.value,
              type = _item$source2.type;
            if (![_Sources.IMAGE_FILE, _Sources.VIDEO_FILE, _Sources.AUDIO_FILE, _Sources.PDF_FILE].includes(type) || (value === null || value === void 0 ? void 0 : value.type) === _Sources.STOCK_MEDIA) {
              return acc;
            }
            var objectValue = getMediaSourceValueObject(value);
            if (signedURLsCache[objectValue.eventDocId] && isValidCache && !isS3ProxyStatusUpdate) {
              return acc;
            }
            acc.push(objectValue.eventDocId);
            return acc;
          }, []);
          /**
           * We won't make an API call when eventDocIds are empty.
           */
          if (eventDocIds.length) {
            _context3.n = 3;
            break;
          }
          if (!isValidCache) {
            _context3.n = 2;
            break;
          }
          return _context3.a(2, getSignedUrlsResponse(items, signedURLsCache));
        case 2:
          return _context3.a(2, items);
        case 3:
          _context3.p = 3;
          _context3.n = 4;
          return apiClient.eventDoc.getSignedUrls(team, event, {
            eventDocs: eventDocIds
          });
        case 4:
          _yield$apiClient$even = _context3.v;
          urls = _yield$apiClient$even.urls;
          // update signedURLCache including last updated timestamp.
          signedURLsCache = _objectSpread(_objectSpread(_objectSpread({}, signedURLsCache), urls), {}, {
            lastUpdated: new Date().getTime()
          });
          response = getSignedUrlsResponse(items, signedURLsCache);
          return _context3.a(2, response);
        case 5:
          _context3.p = 5;
          _t = _context3.v;
          // we probably want to dispatch an error handling action in here
          message = "An error occurred calling eventDoc.getSignedUrls to team: ".concat(team, " event: ").concat(event);
          logger.error(message, _t);
          return _context3.a(2, []);
      }
    }, _callee3, null, [[3, 5]]);
  }));
  return _mapSignedUrlsToSources.apply(this, arguments);
}
function addSignedUrlsToBroadcast(_x9, _x0, _x1, _x10) {
  return _addSignedUrlsToBroadcast.apply(this, arguments);
}
/**
 * Repopulate scene with the correct media audio source
 * @param {{}} sourceScene
 * @param {{}} targetScene
 * @returns {{}}
 */
function _addSignedUrlsToBroadcast() {
  _addSignedUrlsToBroadcast = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(broadcast, apiClient, teamId, eventId) {
    var _broadcast, overlays, backgrounds, globalSceneLayers, program, modifiedOverlays, modifiedBackgrounds, modifiedGlobalSceneLayers, modifiedMediaLayers, updatedProgram, updatedBroadcast;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          _broadcast = broadcast, overlays = _broadcast.overlays, backgrounds = _broadcast.backgrounds, globalSceneLayers = _broadcast.globalSceneLayers, program = _broadcast.program;
          _context4.n = 1;
          return mapSignedUrlsToSources(overlays, apiClient, teamId, eventId);
        case 1:
          modifiedOverlays = _context4.v;
          _context4.n = 2;
          return mapSignedUrlsToSources(backgrounds, apiClient, teamId, eventId);
        case 2:
          modifiedBackgrounds = _context4.v;
          _context4.n = 3;
          return mapSignedUrlsToSources(globalSceneLayers, apiClient, teamId, eventId);
        case 3:
          modifiedGlobalSceneLayers = _context4.v;
          if (!(program !== null && program !== void 0 && program.layers)) {
            _context4.n = 5;
            break;
          }
          _context4.n = 4;
          return mapSignedUrlsToSources(program.layers, apiClient, teamId, eventId);
        case 4:
          modifiedMediaLayers = _context4.v;
          updatedProgram = _objectSpread(_objectSpread({}, program), {}, {
            layers: modifiedMediaLayers
          });
          broadcast = _objectSpread(_objectSpread({}, broadcast), {}, {
            program: updatedProgram
          });
        case 5:
          updatedBroadcast = _objectSpread(_objectSpread({}, broadcast), {}, {
            overlays: modifiedOverlays,
            backgrounds: modifiedBackgrounds,
            globalSceneLayers: modifiedGlobalSceneLayers
          });
          updateProgramIfBackgroundImagePresignedUrlExpired(updatedBroadcast, teamId, eventId, apiClient);
          return _context4.a(2, updatedBroadcast);
      }
    }, _callee4);
  }));
  return _addSignedUrlsToBroadcast.apply(this, arguments);
}
function transferAudioSourceLayer(sourceScene, targetScene) {
  var _sourceScene$layers;
  var sourceSceneAudioLayer = sourceScene === null || sourceScene === void 0 || (_sourceScene$layers = sourceScene.layers) === null || _sourceScene$layers === void 0 ? void 0 : _sourceScene$layers.find(function (layer) {
    return (0, _checkSourceTypes.isAudioSource)(layer === null || layer === void 0 ? void 0 : layer.source);
  });
  if (!sourceSceneAudioLayer) return targetScene;
  var targetSceneAudioLayerIndex;
  var sceneAudioLayer = targetScene.layers.find(function (layer, index) {
    targetSceneAudioLayerIndex = index;
    return (0, _checkSourceTypes.isAudioSource)(layer.source);
  });
  if (!sceneAudioLayer) {
    targetScene.layers.push(sourceSceneAudioLayer);
    return targetScene;
  }
  targetScene.layers[targetSceneAudioLayerIndex] = sourceSceneAudioLayer;
  return targetScene;
}

/**
 * Function to combine sources & swap audio files only if an audio file is already in program
 */
function combineSources(programSources, source) {
  /** Find existing audio sources */
  var audioSourceIndex = programSources.findIndex(function (ps) {
    return (0, _checkSourceTypes.isAudioSource)(ps);
  });
  /** Update incoming source to be unhidden */
  var incomingSource = _objectSpread(_objectSpread({}, source), {}, {
    hidden: false
  });
  /** Update the index of existing audio file in program sources with the new incoming audio file source */
  if (audioSourceIndex >= 0 && (0, _checkSourceTypes.isAudioSource)(source)) {
    programSources[audioSourceIndex] = incomingSource;
    return programSources;
  }
  return [incomingSource].concat(_toConsumableArray(programSources));
}
function uploadForm(_x11, _x12) {
  return _uploadForm.apply(this, arguments);
}
function _uploadForm() {
  _uploadForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(path, keyVals) {
    var config,
      onFailedCallback,
      SLIProps,
      formData,
      _ref2,
      trackContentUploadedSLICallback,
      _ref2$source,
      source,
      _ref2$externalVideoId,
      externalVideoId,
      _ref2$fileSize,
      fileSize,
      res,
      _source$isDragAndDrop,
      _source$isMultiFileUp,
      _args5 = arguments,
      _t2;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.p = _context5.n) {
        case 0:
          config = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {};
          onFailedCallback = _args5.length > 3 ? _args5[3] : undefined;
          SLIProps = _args5.length > 4 ? _args5[4] : undefined;
          formData = new FormData();
          _underscore["default"].each(keyVals, function (val, key) {
            formData.append(key, val);
          });
          _ref2 = SLIProps || {}, trackContentUploadedSLICallback = _ref2.trackContentUploadedSLICallback, _ref2$source = _ref2.source, source = _ref2$source === void 0 ? {} : _ref2$source, _ref2$externalVideoId = _ref2.externalVideoId, externalVideoId = _ref2$externalVideoId === void 0 ? '' : _ref2$externalVideoId, _ref2$fileSize = _ref2.fileSize, fileSize = _ref2$fileSize === void 0 ? 0 : _ref2$fileSize;
          _context5.p = 1;
          _context5.n = 2;
          return _axios["default"].post(path, formData, config);
        case 2:
          res = _context5.v;
          return _context5.a(2, res.data);
        case 3:
          _context5.p = 3;
          _t2 = _context5.v;
          console.error(_t2);
          if (onFailedCallback) {
            onFailedCallback();
          }
          trackContentUploadedSLICallback === null || trackContentUploadedSLICallback === void 0 || trackContentUploadedSLICallback({
            title: source === null || source === void 0 ? void 0 : source.title,
            fileType: source === null || source === void 0 ? void 0 : source.type,
            extension: source === null || source === void 0 ? void 0 : source.ext,
            isDragAndDrop: (_source$isDragAndDrop = source === null || source === void 0 ? void 0 : source.isDragAndDrop) !== null && _source$isDragAndDrop !== void 0 ? _source$isDragAndDrop : false,
            isMultiFileUpload: (_source$isMultiFileUp = source === null || source === void 0 ? void 0 : source.isMultiFileUpload) !== null && _source$isMultiFileUp !== void 0 ? _source$isMultiFileUp : false,
            externalVideoId: externalVideoId,
            fileSize: fileSize,
            error: _t2
          });
        case 4:
          return _context5.a(2);
      }
    }, _callee5, null, [[1, 3]]);
  }));
  return _uploadForm.apply(this, arguments);
}
function uploadEventDoc(_x13, _x14, _x15) {
  return _uploadEventDoc.apply(this, arguments);
}
function _uploadEventDoc() {
  _uploadEventDoc = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(teamId, eventId, file) {
    var studioMedia,
      parentFolderId,
      config,
      onFailedCallback,
      trackContentUploadedSLICallback,
      source,
      externalVideoId,
      fileSize,
      keyVals,
      payload,
      SLIProps,
      _args6 = arguments;
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          studioMedia = _args6.length > 3 && _args6[3] !== undefined ? _args6[3] : false;
          parentFolderId = _args6.length > 4 && _args6[4] !== undefined ? _args6[4] : undefined;
          config = _args6.length > 5 && _args6[5] !== undefined ? _args6[5] : {};
          onFailedCallback = _args6.length > 6 ? _args6[6] : undefined;
          trackContentUploadedSLICallback = _args6.length > 7 ? _args6[7] : undefined;
          source = _args6.length > 8 ? _args6[8] : undefined;
          externalVideoId = _args6.length > 9 ? _args6[9] : undefined;
          fileSize = _args6.length > 10 ? _args6[10] : undefined;
          keyVals = {
            params: JSON.stringify({
              teamId: teamId,
              eventId: eventId
            }),
            file: file
          };
          payload = {};
          if (parentFolderId) {
            payload.parentFolderId = parentFolderId;
          }
          if (studioMedia) {
            payload.studioMedia = studioMedia;
          }
          keyVals.payload = JSON.stringify(payload);
          SLIProps = {
            trackContentUploadedSLICallback: trackContentUploadedSLICallback,
            source: source,
            externalVideoId: externalVideoId,
            fileSize: fileSize
          };
          return _context6.a(2, uploadForm('/api/upload/eventDoc.create', keyVals, config, onFailedCallback, SLIProps));
      }
    }, _callee6);
  }));
  return _uploadEventDoc.apply(this, arguments);
}
function isMediaSourceExcludeAudio(source) {
  return [_Sources.VIDEO_FILE, _Sources.IMAGE_FILE, _Sources.MEDIA, _Sources.PDF_FILE].includes(source.type);
}

/** Reducer util function to find and update broadcast sources */
function findAndUpdateSource(oldSources, updatedSources) {
  return oldSources.map(function (s) {
    var updatedSource = _underscore["default"].find(updatedSources, function (us) {
      return us._id === s._id;
    });
    return !!updatedSource ? updatedSource : s;
  });
}

/*
  This function sets the title of sources without titles to an empty string
*/
function findAndUpdateEmptySourceTitle(sources) {
  return sources.map(function (s) {
    if (!s.title) {
      s.title = '';
    }
    return s;
  });
}

/** Reducer util function to find sources with disconnected state */
function sourcesWithPreviousDisconnectedState(newSources, oldSources) {
  return newSources.map(function (s) {
    var oldSource = _underscore["default"].find(oldSources, function (oldSource) {
      return oldSource._id === s._id;
    });
    if (oldSource) return _objectSpread(_objectSpread({}, s), {}, {
      disconnected: oldSource.disconnected,
      isInitializing: oldSource.isInitializing || false
    });
    return s;
  });
}

/**
 * Marks presenter sources as initializing if their attendee is not present.
 * Director-to-director screen shares are excluded.
 */
function markPresenterSourcesInitializing(sources, attendeePresence) {
  var directorAttendeeIds = new Set(sources.filter(function (s) {
    return s.value !== _Sources.UNASSIGNED && _Sources.SOURCE_ROLE_HOST === s.role;
  }).map(function (s) {
    return s.value;
  }));
  return sources.map(function (source) {
    if (source.value !== _Sources.UNASSIGNED && [_Sources.CAMERA_PRESENTER, _Sources.SCREEN_PRESENTER].includes(source.type) && !attendeePresence.includes(source.value)) {
      var _source$value;
      // Don't mark director-to-director screen shares as initializing
      if (_Sources.SCREEN_PRESENTER === source.type && directorAttendeeIds.has((_source$value = source.value) === null || _source$value === void 0 ? void 0 : _source$value.split('#')[0])) {
        return _objectSpread(_objectSpread({}, source), {}, {
          isInitializing: false
        });
      }
      return _objectSpread(_objectSpread({}, source), {}, {
        isInitializing: true
      });
    }
    return source;
  });
}
function getAttendeeIds(sources) {
  return sources.filter(function (source) {
    return (0, _checkSourceTypes.isCameraPresenter)(source);
  }).map(function (source) {
    return (source === null || source === void 0 ? void 0 : source.value) === _Sources.UNASSIGNED ? "".concat(_Sources.UNASSIGNED, "-").concat(source === null || source === void 0 ? void 0 : source._id) : source === null || source === void 0 ? void 0 : source.value;
  });
}

/** We want to unmute all staged sources and mute all other sources */
function getAttendeesNextMuteStatuses(stagedSources, broadcastSources) {
  var stagedAttendeeIds = getAttendeeIds(stagedSources);
  var allAttendeeIds = getAttendeeIds(broadcastSources);
  var nextMuteStatuses = allAttendeeIds.reduce(function (memo, attendeeId) {
    var isMuted = !stagedAttendeeIds.includes(attendeeId);
    return _objectSpread(_objectSpread({}, memo), {}, _defineProperty({}, attendeeId, isMuted));
  }, {});
  return nextMuteStatuses;
}

/**
 * Util for toggling the hidden status of an banners, backgrounds
 * with the following structure [{ _id, layer: {}, source: {}}]
 * we can only have one un-hidden at a time
 */
function toggleStatus(itemId, items) {
  var _items$reduce;
  return (_items$reduce = items === null || items === void 0 ? void 0 : items.reduce(function (acc, item) {
    var source = item.source,
      _id = item._id;
    var isItemHidden = !(_id === itemId && source.hidden);
    return [].concat(_toConsumableArray(acc), [_objectSpread(_objectSpread({}, item), {}, {
      source: _objectSpread(_objectSpread({}, source), {}, {
        hidden: isItemHidden
      })
    })]);
  }, [])) !== null && _items$reduce !== void 0 ? _items$reduce : [];
}

/**
 * Util for toggling the hidden status of banners
 * with the following structure [{ _id, layer: {}, source: {}}]
 * Differentiates between presenter banners and custom banners - only one can be visible within each category
 */
var toggleBannerStatus = exports.toggleBannerStatus = function toggleBannerStatus(itemId, items) {
  var _targetItem$source;
  // Find the item being toggled to determine its type
  var targetItem = items.find(function (item) {
    return item._id === itemId;
  });
  if (!targetItem) return items;
  var isTargetPresenterBanner = ((_targetItem$source = targetItem.source) === null || _targetItem$source === void 0 || (_targetItem$source = _targetItem$source.value) === null || _targetItem$source === void 0 ? void 0 : _targetItem$source.templateType) === _Banners.PRESENTER_BANNER;
  return items.reduce(function (acc, item) {
    var _source$value2;
    var source = item.source,
      _id = item._id;
    var isItemPresenterBanner = (source === null || source === void 0 || (_source$value2 = source.value) === null || _source$value2 === void 0 ? void 0 : _source$value2.templateType) === _Banners.PRESENTER_BANNER;

    // Only toggle items of the same category (presenter banners vs custom banners)
    var isSameCategory = isItemPresenterBanner === isTargetPresenterBanner;
    var isItemHidden = isSameCategory ? !(_id === itemId && source.hidden) : source.hidden;
    return [].concat(_toConsumableArray(acc), [_objectSpread(_objectSpread({}, item), {}, {
      source: _objectSpread(_objectSpread({}, source), {}, {
        hidden: isItemHidden
      })
    })]);
  }, []);
};
function isSourceInLayer(source, layers) {
  var sourceId = source._id;
  return layers.some(function (layer) {
    return layer.source._id === sourceId;
  });
}
function getScreenShareCount(sources) {
  return sources.filter(function (s) {
    return s.type === _Sources.SCREEN_PRESENTER;
  }).length;
}
function isMediaSource(sourceType) {
  return [_Sources.VIDEO_FILE, _Sources.AUDIO_FILE, _Sources.IMAGE_FILE, _Sources.PDF_FILE, _Sources.MEDIA].includes(sourceType);
}
function isCameraSource(sourceType) {
  return sourceType === _Sources.CAMERA_PRESENTER;
}
function getGroupSources(sources, groupType) {
  if (isMediaSource(groupType)) {
    return sources.filter(function (s) {
      return isMediaSource(s.type);
    });
  }
  if (isCameraSource(groupType)) {
    return sources.filter(function (s) {
      return isCameraSource(s.type);
    });
  }
}
function getStartedOn(isPlaying) {
  var serverTimeDelta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return isPlaying ? (0, _moment["default"])().utc().unix() - serverTimeDelta + _MediaPlayer.PLAY_DELAY : undefined;
}
function getSceneLayerIds(broadcast) {
  var globalSceneLayers = broadcast.globalSceneLayers;
  var sceneLayers = globalSceneLayers.length ? globalSceneLayers : ['SCENE_LAYER'];
  return sceneLayers.map(function (sl) {
    return sl._id ? sl._id : sl;
  });
}

/**
 * This logic handles the positioning of the background. Backgrounds should
 * always come first and only one can be visible at a time.
 *
 * @param sceneLayerIds
 * @param hidden
 * @param backgroundId
 * @returns {*}
 */
function getUpdatedSceneLayers(sceneLayerIds, hidden, backgroundId) {
  if (!hidden) {
    // the background has been made visible

    if (sceneLayerIds[0] !== 'SCENE_LAYER') {
      // if any other background exists remove it first
      sceneLayerIds.splice(0, 1);
    }

    // make this the current background
    sceneLayerIds.unshift(backgroundId);
  } else {
    // the background has been made invisible. remove it
    sceneLayerIds = sceneLayerIds.filter(function (slId) {
      return !(slId === backgroundId);
    });
  }
  return sceneLayerIds;
}

/**
 * Filters a list of meeting attendees to return only those with their camera turned on.
 * This excludes screen share participants.
 * @param {Object} attendeeTiles - An object where keys are the IDs of attendees in the meeting.
 * @param {Object} attendeeCameraStatus - An object mapping attendee IDs to their camera status (true for on, false for off).
 * @returns {string[]} An array of attendee IDs who have their camera on.
 */
var attendeesWithCameraOn = exports.attendeesWithCameraOn = function attendeesWithCameraOn(attendeeTiles, attendeeCameraStatus) {
  var attendeesInMeetings = Object.keys(attendeeTiles);
  // Exclude screen share attendees
  var cameraAttendeesInMeeting = attendeesInMeetings.filter(function (attendeeId) {
    return !attendeeId.includes('#content');
  });
  return cameraAttendeesInMeeting.filter(function (attendeeId) {
    return attendeeCameraStatus[attendeeId] === true;
  });
};

/**
 * Checks if the number of active cameras in a meeting has exceeded the defined limit.
 * The camera limit can vary based on the meeting vendor (e.g., Agora).
 * @param {Object} attendeeTiles - An object where keys are the IDs of attendees in the meeting.
 * @param {Object} attendeeCameraStatus - An object mapping attendee IDs to their camera status.
 * @returns {boolean} True if the camera limit has been exceeded, false otherwise.
 */
var hasMeetingExceededCameraLimit = exports.hasMeetingExceededCameraLimit = function hasMeetingExceededCameraLimit(attendeeTiles, attendeeCameraStatus) {
  var useAgora = (0, _featureFlags.shouldHaveFeature)('studio.meetingVendor') === _Vendor.VENDOR_AGORA;
  var cameraLimit = useAgora ? _Sources.MAX_AGORA_CAMERA_COUNT : _Sources.MAX_CAMERA_COUNT;
  var cameraAttendees = attendeesWithCameraOn(attendeeTiles, attendeeCameraStatus);
  return cameraAttendees.length >= cameraLimit;
};

/**
 * Will adding a camera presenter exceed the camera presenter limit?
 *
 * @param sources
 * @param newSource
 */
function willExceedCameraLimit(sources, newSource) {
  var cameraSources = (0, _getSources.getCameraSources)(sources);
  return newSource.type === _Sources.CAMERA_PRESENTER && cameraSources.length >= _SceneLayouts.CAMERA_PRESENTER_LIMIT;
}

/**
 * Will return file in binary format
 *
 * @param backgrounds
 * @param backgroundIdToUpdate
 * @param newUrl
 */
function readFileAsBinary(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.onload = function () {
      var binaryData = reader.result;
      resolve(binaryData);
    };
    reader.onerror = function () {
      reject(reader.error || new Error('Failed to read file'));
    };
    reader.readAsArrayBuffer(file);
  });
}

/**
 * Preserves PDF URLs from old sources when updating to new sources
 *
 * This function ensures that when sources are updated, any PDF files in the collection
 * retain their original URLs. This prevents re-renders during source updates.
 *
 * @param {Array} newSources - The new/updated collection of source objects
 * @param {Array} oldSources - The original collection of source objects before update
 * @returns {Array} - Updated collection of sources with PDF URLs preserved from old sources
 */
function retainPDFURLsInSources(newSources, oldSources) {
  return newSources.map(function (source) {
    var oldSource = oldSources.find(function (s) {
      return s._id === source._id;
    });
    if (oldSource && oldSource.type === _Sources.PDF_FILE) {
      var _oldSource$value, _source$value3;
      return _objectSpread(_objectSpread({}, source), {}, {
        value: _objectSpread(_objectSpread({}, source.value), {}, {
          url: ((_oldSource$value = oldSource.value) === null || _oldSource$value === void 0 ? void 0 : _oldSource$value.url) || ((_source$value3 = source.value) === null || _source$value3 === void 0 ? void 0 : _source$value3.url)
        })
      });
    }
    return source;
  });
}

/**
 * Returns a filtered object containing only the attendee statuses
 * with keys that include 'UNASSIGNED'.
 *
 * @param attendeeStatuses
 * @returns {Object} - Filtered object with unassigned attendee statuses
 */
var filterUnassignedSources = exports.filterUnassignedSources = function filterUnassignedSources(attendeeStatuses) {
  return Object.keys(attendeeStatuses).filter(function (key) {
    return key.includes(_Sources.UNASSIGNED);
  }).reduce(function (acc, key) {
    acc[key] = attendeeStatuses[key];
    return acc;
  }, {});
};

/**
 * Returns true if the number of available screen share slots is sufficient for all screen share
 * share requests, else false.
 *
 * @param {array} sources
 * @param {array} pendingKnocks
 * @returns {boolean}
 */
var getShouldApproveScreenShares = exports.getShouldApproveScreenShares = function getShouldApproveScreenShares(pendingKnocks, sources) {
  var screenShareSourceCount = sources.filter(function (source) {
    return source.value !== _Sources.UNASSIGNED && source.type === _Sources.SCREEN_PRESENTER;
  }).length;
  var screenShareRequestCount = pendingKnocks.filter(function (pendingKnock) {
    return pendingKnock.type === _Knocks.SCREENSHARE;
  }).length;
  var availableSlots = _SceneLayouts.SCREEN_PRESENTER_LIMIT - screenShareSourceCount;
  return availableSlots >= screenShareRequestCount;
};